import { client } from 'api';

type Token = string;

export const getPasswordChangeLink = (token: Token) =>
  client.post(`auth/change-pw?token=${token}`);
